import { TitleOption, TITLE_OTHER_EN, TITLE_OTHER_TH } from "const";
import find from "lodash/find";

export const checkTitleAgainstGender = (info) => {
  const _info = { ...info };
  const titles = [];

  _info.isGenderAndTitleInvalid = !(_info.validTitle ?? true);

  if (_info.isGenderAndTitleInvalid && _info.titleList) {
    // prepare title list options
    _info.titleList.forEach((t) => {
      const title = find(titles, { titleDesc: t.titleDesc });
      if (!title) titles.push(t);
      else if (!title.sexCode || !t.sexCode || title.sexCode !== t.sexCode) title.sexCode = "";
    });

    // prepare title
    const titleMainOptions = _info.thai ? TitleOption.TH : TitleOption.EN;
    const isTitleOnMainOption = titleMainOptions.map((t) => t.value).includes(_info.title);
    if (!isTitleOnMainOption) {
      _info.titleOther = _info.title;
      _info.titleOtherOption = find(titles, { titleDesc: _info.titleOther });
      _info.title = _info.thai ? TITLE_OTHER_TH : TITLE_OTHER_EN;
    }
  }

  return {
    titles,
    prepareTitle: !!(_info.isGenderAndTitleInvalid && _info.titleList),
    invalid: _info.isGenderAndTitleInvalid,
    info: _info,
  };
};
